<template>
	<div data-tour-scope="warehouse-cashout">
		<!--		<v-navigation-drawer fixed v-model="navStateFilter" :clipped="$vuetify.breakpoint.lgAndUp" app right class="mt-0" style="top: 0; height: 100%; max-height: 100%" width="350">
			<v-card-title>
				{{ this.$vuetify.lang.t('$vuetify.front.filters') }}
				<v-spacer></v-spacer>
			</v-card-title>
			<v-list dense>
				<v-list-item>
					<v-text-field hide-details="auto" @keyup="searchit" v-model="searchfield" append-icon="search" label="Search" dense></v-text-field>
				</v-list-item>
			</v-list>
		</v-navigation-drawer>-->
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center v-resize="onResize">
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title> {{ this.$vuetify.lang.t('$vuetify.front.warehouse.home') }} / {{ this.$vuetify.lang.t('$vuetify.front.warehouse.cashout') }}</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()">
							<v-icon left>mdi-school-outline</v-icon>
							Tutorial guidato
						</v-btn>

							<v-spacer></v-spacer>

							<v-toolbar-items shift>
								<v-menu bottom :close-on-click="closeOnClick" elevation-0>
									<template v-slot:activator="{ on, attrs }">
										<v-btn elevation="0" v-bind="attrs" v-on="on" text data-tour="add">
											<v-icon>mdi-plus</v-icon>
										</v-btn>
									</template>

									<v-list elevation="0">
										<v-list-item @click="createItem">
											<v-list-item-icon>
												<v-icon>mdi-plus</v-icon>
											</v-list-item-icon>

											<v-list-item-content>
												<v-list-item-title>Aggiungi prodotto</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
										<!--@click="getItemsShopifyAz"-->
									</v-list>
								</v-menu>
								<!--<v-divider vertical></v-divider>
-->
							</v-toolbar-items>
						</v-toolbar>

						<v-container>
						<v-alert outlined text type="info"> Usare il lettore barcode per leggere i codici dei prodotti </v-alert>
							<v-row>
								<v-col sm="8" offset-md="2" data-tour="scan">
									<v-text-field hide-details="auto" readonly outlined append-icon="mdi-barcode" v-model="sku"></v-text-field>
									<qr-scan-panel class="mt-2 mb-2" data-tour="phone" @code="processScan" />
								</v-col>
							</v-row>

							<div v-if="getErrors.length > 0">
								<v-container>
									<v-alert outlined text type="error" v-for="error in getErrors" :key="error"> {{ error }}</v-alert>
								</v-container>
							</div>
							<!-- telefono: ogni prodotto candidato della lettura diventa una card -->
							<div v-if="getElement.length > 1 && mobileCards" data-tour="candidates" class="kv-list pb-3">
								<key-value-card v-for="item in getElement" :key="item.name" :title="item.trans.name" :fields="campiCandidato(item)">
									<template v-if="item.variants?.variants?.length > 0" v-slot:top>
										<div class="mb-1">
											<v-chip v-for="el in item.variants.variants" :key="el._id" :ripple="false" class="mr-2 mb-2" small>
												<b class="mr-2">{{ el.name.trans }}</b> {{ el.value.trans }}
											</v-chip>
										</div>
									</template>
									<v-btn block large color="success" dark @click="updateinventory(item)"> CONFERMA</v-btn>
								</key-value-card>
							</div>
							<v-simple-table key="table-branch-1" v-else-if="getElement.length > 1" data-tour="candidates">
								<thead>
									<tr>
										<th class="text-left">Brand</th>
										<th class="text-left">Name</th>
										<th class="text-left">Variante</th>
										<th class="text-left">Sku</th>
										<th class="text-left">Ean</th>

										<th class="text-left">Qt x unità</th>

										<th class="text-left">Azione</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="item in getElement" :key="item.name">
										<td>{{ item.brand.trans.name }}</td>
										<td>{{ item.trans.name }}</td>
										<td>
											<v-chip v-for="el in item.variants?.variants" v-if="item.variants?.variants?.length > 0" :key="el._id" :ripple="false" class="mr-2 mb-2">
												<b class="mr-2">{{ el.name.trans }}</b> {{ el.value.trans }}
											</v-chip>
										</td>
										<td>{{ item?.variants?.sku }}</td>
										<td>{{ item?.variants?.ean }}</td>

										<td>{{ item?.variants?.qtunit }}</td>

										<td>
											<p>
												<v-btn x-large color="success" dark class="mt-3" @click="updateinventory(item)"> CONFERMA</v-btn>
											</p>
										</td>
									</tr>
								</tbody>
							</v-simple-table>

							<!-- telefono: ogni riga del carrello diventa una card, sotto il riepilogo con totale e pulsanti -->
							<div v-if="getItems.length > 0 && mobileCards" data-tour="cart" class="kv-list cashout-cards pb-3">
								<key-value-card v-for="(item, index) in getItems" :key="index" :title="item.name" :image="getImage(item) || ''" :fields="campiCarrello(item)">
									<template v-slot:actions>
										<v-btn icon color="error" @click="deleteItem(item)">
											<v-icon>mdi-trash-can-outline</v-icon>
										</v-btn>
									</template>
									<template v-if="item.variant && getVariants(item.variant).length > 0" v-slot:top>
										<div class="mb-1">
											<v-chip v-for="(el, i) in getVariants(item.variant)" :key="i" :ripple="false" class="mr-2 mb-2" small>
												<b class="mr-2">{{ el.name }}</b> {{ el.value }}
											</v-chip>
										</div>
									</template>
									<v-text-field v-model="item.qt" type="number" @change="updateQt(item)" @input="updateQt(item)" label="Qt" outlined dense hide-details />
								</key-value-card>
								<!-- riepilogo del carrello: totale ben visibile e azioni finali -->
								<v-card outlined class="kv-card cashout-summary">
									<div class="px-3 py-3">
										<div class="d-flex align-center justify-space-between" data-tour="total">
											<span class="card-label">Prezzo totale</span>
											<span class="text-h6 font-weight-bold">{{ getTotalCart }}</span>
										</div>
										<div class="d-flex mt-3">
											<v-btn large color="info" dark class="flex-grow-1 mr-2" data-tour="cancel" @click="deleteCart(item)"> ANNULLA</v-btn>
											<v-btn large color="success" dark class="flex-grow-1" data-tour="checkout" @click="confermaCart()"> CONCLUDI</v-btn>
										</div>
									</div>
								</v-card>
							</div>
							<v-simple-table class="elevation-0" v-else-if="getItems.length > 0" data-tour="cart">
								<thead>
									<tr>
										<th class="text-left"></th>
										<!--										<th class="text-left">Brand</th>-->
										<!--										<th class="text-left">Category</th>-->
										<!--										<th class="text-left">Model</th>-->
										<th class="text-left">Image</th>
										<th class="text-left">Name</th>
										<th class="text-left">Variante</th>
										<!--										<th class="text-left">Sku</th>-->

										<!--										<th class="text-left">Ean</th>-->
										<th class="text-left">Qt x unità</th>
										<th class="text-left">Price</th>

										<th class="text-left">Quantità</th>
										<th class="text-left">Parziale</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, index) in getItems" :key="index">
										<td>
											<v-btn x-large color="error" dark @click="deleteItem(item)"> ELIMINA</v-btn>
										</td>

										<!--										<td>{{ item.brand }}</td>-->
										<!--										<td>{{ item.category }}</td>-->
										<!--										<td>{{ item.model }}</td>-->
										<td>
											<template v-if="getImage(item)">
												<img :src="getImage(item)" style="height: 100px" />
											</template>
										</td>
										<td>
											<span>{{ item.name }}</span
											><br />
											<small>{{ item?.sku ? 'SKU: ' + item?.sku + ' - ' : '' }} {{ item?.sku ? 'EAN: ' + item?.ean : '' }}</small>
										</td>
										<td>
											<template v-for="el in getVariants(item.variant)" v-if="getVariants(item.variant).length > 0">
												<v-chip :ripple="false" class="mr-2 mb-2" small>
													<b class="mr-2">{{ el.name }}</b> {{ el.value }}
												</v-chip>
											</template>
										</td>

										<!--										<td>{{ item.sku }}</td>-->
										<!---->
										<!--										<td>{{ item.ean }}</td>-->
										<td>{{ item.qtunit }}</td>
										<td>{{ item.price }}</td>

										<td>
											<v-text-field hide-details="auto" class="mt-4" v-model="item.qt" type="number" @change="updateQt(item)" @input="updateQt(item)" label="Qt" outlined />
										</td>
										<td>{{ (item.price * item.qt).toFixed(2) }}</td>

										<!--td>{{ item.id }}</td-->
									</tr>
									<tr>
										<td class="pl-0 pr-0 ml-0 mr-0" style="width: 5px"></td>

										<td></td>
										<td></td>
										<td></td>
										<td></td>

										<td></td>

										<td></td>
										<td><v-text-field hide-details="auto" class="mt-4" v-model="getTotalCart" data-tour="total" label="Prezzo totale" type="number" outlined readonly /></td>

										<!--td>{{ item.id }}</td-->
									</tr>
									<tr>
										<td>
											<v-btn x-large color="info" dark class="mt-3 mb-3" data-tour="cancel" @click="deleteCart(item)"> ANNULLA</v-btn>
										</td>

										<td></td>
										<td></td>
										<td></td>
										<td></td>
										<td></td>

										<td></td>
										<td><v-btn x-large color="success" dark class="mt-3 mb-3" data-tour="checkout" @click="confermaCart()"> CONCLUDI</v-btn></td>

										<!--td>{{ item.id }}</td-->
									</tr>
								</tbody>
							</v-simple-table>
						</v-container>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar = false"> Close </v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>
		<v-dialog :value="getDialog" fullscreen hide-overlay eager transition="dialog-bottom-transition" persistent internal-activator no-click-animation :eager="true" :retain-focus="false">
			<FormCreate v-if="operation === 'FormCreate'" :key="componentKey" @event="getDataFromApi" @message="propSetMessages"></FormCreate>
		</v-dialog>

		<v-dialog v-model="dialogconfirmdelete" max-width="290">
			<v-card>
				<v-card-title class="headline">Sei sicuro?</v-card-title>
				<v-card-text>Confermando l'operazione l'inventario sarà cancellato </v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn color="primary" text @click="dialogconfirmdelete = false"> Annulla </v-btn>

					<v-btn color="primary" text @click="confirmDeleteInventario"> Conferma </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="dialogconfirmImport" max-width="290">
			<v-card>
				<v-card-title class="headline">Sei sicuro?</v-card-title>
				<v-card-text>Confermando l'operazione i prodotti verranno aggiornati e l'inventario sarà confermato </v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn color="primary" text @click="dialogconfirmImport = false"> Annulla </v-btn>

					<v-btn color="primary" text @click="confirmCart"> Conferma </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- Ultimo elemento: il nodo viene spostato in `[data-app]` al montaggio. -->
		<TourOverlay :tour="tour"></TourOverlay>
	</div>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import VuetifyDraggableTreeview from 'vuetify-draggable-treeview';
import axios from 'axios';

Vue.use(VuetifyDraggableTreeview);

const FormCreate = () => import('@/components/carts/Create.vue');

import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import QrScanPanel from '@/components/warehouse/QrScanPanel.vue';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createWarehouseCashoutTourSteps } from './warehouse-cashout-tour';

export default {
	name: 'Cashout',
	/*
	 * Il controller del tutorial nasce qui e non in `data()`: quello che sta in
	 * `data()` viene reso reattivo in profondita da Vue 2, e in quel passaggio i
	 * `ref` del motore verrebbero srotolati nel loro valore grezzo.
	 */
	setup() {
		return {
			tour: useTour(createWarehouseCashoutTourSteps()),
		};
	},
	data() {
		return {
			dialogconfirmUpdate: false,
			componentKey: 0,
			right: true,
			permanent: false,
			miniVariant: false,
			expandOnHover: false,
			background: false,
			clippedOrder: 0,
			linkdownload: '',
			paramsUrls: '',
			items: [],
			setinterval: '',
			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			// ricerca
			settings: {
				search: '',
				filters: {
					categories: [],
					brand: [],
					variants: [],
				},
				options: {
					sortBy: ['created_at'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15,
				},
			},
			listSize: [15, 25, 50, 100],
			searchfield: '',
			selected: [],
			selectedall: [],
			total: 0,
			headers: [
				{ text: '', value: '' },

				{ text: 'Creazione', value: 'created_at', sortable: true },
				{ text: 'Immagine', value: 'image', sortable: false },
				{ text: 'Brand', value: 'brand', sortable: false },
				{ text: 'Categoria', value: 'category', sortable: false },
				{ text: 'Modello', value: 'model' },
				{ text: 'Nome', value: 'name' },
				{ text: 'Variante', value: 'variant', sortable: false },
				{ text: 'Sku', value: 'sku' },
				{ text: 'Supplier', value: 'supplier' },
				{ text: 'Ean', value: 'ean' },
				{ text: 'Quantità', value: 'qt' },
			],
			disabled: false,
			absolute: false,
			openOnHover: false,
			value: false,
			closeOnClick: true,
			closeOnContentClick: true,
			offsetX: false,
			offsetY: true,
			dialogconfirm: false,
			dialogconfirmdelete: false,
			dialogconfirmImport: false,
			isActive: true,
			show1: false,
			messages: {
				email: [],
				name: [],
				password: [],
			},
			listCategories: [],
			treeCategories: [],
			selectVariants: [],
			arrayTree: [],
			Totale: '',
			Fee: '',
			Refund: '',
			Gain: '',
			page: 1,
			isMobile: false,
			operation: '',
			magento: false,
			shopify: false,
			fattureincloud: false,
			langDefault: '',
			brands: [],
			selectionType: 'leaf',
			findParant: [],
			open: [1, 2],
			selectColor: ['red', 'pink', 'purple', 'indigo', 'blue', 'green', 'yellow', 'orange', 'grey'],
			menu: false,
			sku: '',
			code: '',
		};
	},
	/*created () {
            this.setDialog(false)
            this.initialize();

        },*/
	filters: {
		fixed: function (value) {
			if (!value) return '';
			return value.toFixed(2);
		},
	},
	async created() {
		this.setDialog(false);
		this.setExistFilter(true);
		this.linkdownload = `${this.getUrl}nocors/items/download`;
		await this.fetchSetting();
		let promises = [];
		promises.push(this.fetchSetting());
		//promises.push(this.fetchService(['ebay', 'magento', 'shopify', 'fattureInCloud']));

		this.langDefault = _.find(this.getSettings.languages, { default: true }).lang;

		this.fetchSelect({}).then(result => {
			this.brands = result.data;
		});
	},
	watch: {
		selectedLength(val) {
			if (val > 0) {
				this.selectedall = [-1];
			}
		},
		'settings.options': {
			handler: function (val) {
				if (_.isUndefined(this.settings.options.sortBy[0]) && this.settings.options.sortBy[0] !== '') {
					let outcome = this.getSortDesc;
					outcome = !outcome;
					this.settings.options.sortBy = [];
					this.settings.options.sortDesc = [];
					this.settings.options.sortBy.push(this.getSortBy);
					this.settings.options.sortDesc.push(outcome);
				}
				if (val.page === this.page) {
					this.settings.options.page = 1;
				}
				this.page = val.page;

				this.getDataFromApi();
			},
			deep: true,
		},
		fab: {
			top(val) {
				this.fab.bottom = !val;
			},
			right(val) {
				this.fab.left = !val;
			},
			bottom(val) {
				this.fab.top = !val;
			},
			left(val) {
				this.fab.right = !val;
			},
		},
	},
	components: {
		FormCreate,
		TourOverlay,
		QrScanPanel,
		KeyValueCard,

		//VuetifyDraggableTreeview
	},
	computed: {
		selectedLength() {
			return this.selected.length;
		},
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getToken: 'profile/getToken',
			getUrl: 'settings/getUrl',

			getDialog: 'settings/getDialog',
			getPreload: 'settings/getPreload',
			getSnackbar: 'snackbars/getSnackbar',
			getColor: 'snackbars/getColor',
			getMultiline: 'snackbars/getMultiline',
			getTimeout: 'snackbars/getTimeout',
			getVertical: 'snackbars/getVertical',
			getText: 'snackbars/getText',
			getIndex: 'inventories/getIndex',
			getItems: 'cart/getItems',
			getLanguage: 'profile/getLanguage',
			getDrawerFilter: 'settings/getDrawerFilter',
			getSortBy: 'inventories/getSortBy',
			getSortDesc: 'inventories/getSortDesc',
			getCategoriesTree: 'categories/getCategoriesTree',
			getCategoriesChildrean: 'categories/getCategoriesChildrean',
			getSettings: 'settings/getSetting',
			getServices: 'services/getServices',
			getElement: 'warehouse/getItems',
			getTotalCart: 'cart/getTotalCart',
			getErrors: 'warehouse/getErrors',
		}),

		navStateFilter: {
			get: function () {
				return this.getDrawerFilter;
			},
			set: function () {
				return this.getDrawerFilter;
			},
		},
		navStateOrder: {
			get: function () {
				return this.clippedOrder;
			},
			set: function () {
				return this.clippedOrder;
			},
		},
	},
	methods: {
		...mapMutations({
			setLogout: 'profile/setLogout',
			setDialog: 'settings/setDialog',

			setPreload: 'settings/setPreload',
			setSnackbar: 'snackbars/setSnackbar',
			setClearError: 'settings/setClearError',
			setMessages: 'settings/setMessages',
			setItems: 'cart/setItems',
			setElements: 'warehouse/setItems',

			setItem: 'inventories/setItem',
			setIndex: 'inventories/setIndex',
			setExistFilter: 'settings/setExistFilter',
			setDrawerFilter: 'settings/setDrawerFilter',
			setErrors: 'warehouse/setErrors',
			resetErrors: 'warehouse/resetErrors',
		}),
		...mapActions({
			fetchItems: 'ddts/asyncFetchData',
			deleteItems: 'cart/delete',
			deleteCarts: 'cart/deletecart',
			confirmCarts: 'cart/confirmCarts',
			updateCart: 'cart/updateQt',
			deleteInventory: 'ddts/deleteInventory',
			confirmCart: 'cart/confirmCarts',
			updateItems: 'ddts/updateItems',
			destroyData: 'ddts/destroyData',
			saveData: 'users/saveData',
			fetchSetting: 'settings/asyncFetchData',
			fetchLists: 'brands/fetchLists',
			fetchSelect: 'brands/fetchSelect',
			setUpdateStatusItem: 'inventories/setUpdateStatusItem',
			setUpdateStatusItemVariant: 'inventories/setUpdateStatusItemVariant',
			fetchService: 'services/getServiceFetch',
			fetchServiceactive: 'services/getServiceFetchActive',
			getWarehouse: 'warehouse/getDetailSingle',
			saveInventory: 'warehouse/saveDdt',
			addTocart: 'cart/add',
			//'resetMessages' : 'settings/resetMessages'
		}),
		convertSearch(match) {
			let result = match;

			if (this.settings?.search && result) {
				let re = new RegExp(this.settings.search, 'gi');
				result = match.replace(re, `<mark>${this.settings.search}</mark>`);
			}
			return result;
		},
		async onKeypress(event) {
			this.resetErrors([]);
			/*console.log('KEYCODE', event.keyCode);
      console.log('CODE', event.key);
      console.log('CODING', this.code);*/
			if (event.keyCode === 13) {
				await this.processScan(this.code);
			} else {
				this.sku = '';
				this.code += event.key;
			}
		},

		// Unico punto di ingresso dei codici letti: pistola USB (Invio) e telefono (QrScanPanel).
		async processScan(code) {
			this.resetErrors([]);
			this.code = code;
			await this.getWarehouse({ search: this.code });
			if (this.getElement.length === 0) {
				this.setErrors('Nessun prodotto trovato per questo codice');
			}
			if (this.getElement.length === 1) {
				const item = this.getElement[0];
				item.variants.qt = 1;
				await this.addTocart(item);
			}
			this.sku = this.code;
			/*console.log('SKU = ', this.sku);
        console.log('CODE = ', this.code);*/
			this.code = '';
			/*if (this.code.length > 10) {
          await this.scanElaboration();
        }*/
		},
		getImageMarketplace(img) {
			let logo = '';

			switch (img) {
				case 'Amazon':
					logo = require(`@/assets/images/Amazon.svg`);
					break;
				case 'Ebay':
					logo = require(`@/assets/images/Ebay.svg`);
					break;
				case 'Magento':
					logo = require(`@/assets/images/Magento.svg`);
					break;
				case 'Shopify':
					logo = require(`@/assets/images/framework/shopify.svg`);
					break;
				case 'Store':
					logo = require(`@/assets/images/store.svg`);
					break;
				default:
					logo = require(`@/assets/images/flag/map.svg`);
			}
			return logo;
		},
		getImageFlag(img) {
			try {
				return require(`@/assets/images/flag/${img}.svg`);
			} catch (e) {
				return require(`@/assets/images/flag/map.svg`);
			}
		},
		imageUrlAlt(index) {
			// console.log("E",require(`@/assets/images/picture.svg`))
			//  console.log("EVENT",event)
			//   event.target.src = require(`@/assets/images/picture.svg`)
			//console.log(this.$refs[index])
			this.$refs[index][0].src = require(`@/assets/images/picture.svg`);
		},
		filterCheck(event) {
			this.settings.filters.categories = _.map(event, '_id');
		},
		createImage(item) {
			let image = '';

			try {
				if (item?.image) {
					image = item.image;
				} else {
					throw 'no image';
				}

				return image;
			} catch (e) {
				return require(`@/assets/images/picture.svg`);
			}
			//return image;
			//require(`@/assets/images/picture.svg`)
		},
		toggle(event) {
			if (_.size(this.selectedall) === 0) {
				this.selected = [];
			} else {
				//console.log(this.selected[0])
				if (event[0] !== -1) {
					this.selected = [];
					_.forEach(this.getItems, cat => {
						this.selected.push(cat._id);
					});
				}
			}
		},
		toggleDrawerFilter() {
			this.setDrawerFilter(!this.getDrawerFilter);
			this.clippedOrder = 0;
			//this.$store.commit('setDrawer') = !this.$store.state.drawer;
		},

		download() {
			return (
				'nocors/items/download?token=' +
				this.getToken +
				'&search=' +
				this.searchfield +
				'&categories=' +
				this.settings.filters.categories +
				'&brands=' +
				this.settings.filters.brands +
				'&selected=' +
				this.selected
			);
		},
		onResize() {
			this.isMobile = window.innerWidth < 769;
		},
		filterName(data) {
			return _.find(data, { lang: this.getLanguage }).text;
			//return text
		},
		changeFlag(item, color) {
			let url = 'items/update-flag';
			let payload = item;
			this.preload = true;
			this.editIndex = this.getItems.indexOf(item);
			axios
				.post(`${this.getUrl}${url}`, { item: payload, color: color }, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(() => {
					this.preload = false;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					Object.assign(this.getItems[this.editIndex], { Color: color });
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}
						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},

		changeStatus(item) {
			try {
				this.setPreload(true);

				this.setUpdateStatusItem({
					_id: item._id,
					id: item.id,
					is_active: item.is_active,
				}).then(() => {
					//this.total = result.total
					//this.items = result.data.data
					this.setPreload(false);
					this.getDataFromApi().then(() => {
						this.snackbar.color = 'success';
						this.snackbar.text = 'Update successfully';
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.selected = [];
						this.selectedall = [];
						this.setPreload(false);
					});
					/*if (result.data.data.ok) {
                            this.snackbar.color = "success";
                            this.snackbar.text = "Update successfully";
                            this.snackbar.snackbar = true;
                            this.snackbar.mode = 'multi-line';
                            this.snackbar.timeout = 5000;
                        }*/
				});

				//console.log(response);
			} catch (err) {
				console.log(err);
			}

			//console.log(item)
		},
		changeStatusVariant(item) {
			try {
				this.setPreload(true);

				this.setUpdateStatusItemVariant({
					_id: item._id,
					id: item.id,
					variants: item.variants._id,
					active: item.variants.active,
				}).then(result => {
					//this.total = result.total
					//this.items = result.data.data
					if (result.data.data.ok) {
						this.snackbar.color = 'success';
						this.snackbar.text = 'Update successfully';
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
					}
					this.setPreload(false);
				});

				//console.log(response);
			} catch (err) {
				console.log(err);
			}

			//console.log(item)
		},

		async duplicateItem(key) {
			this.componentKey += 1;
			this.setClearError({});

			this.operation = 'FormDuplicate';
			let item;
			if (!key) {
				let el = this.selected[0];
				item = _.find(this.getItems, i => {
					return i._id === el;
				});
			} else {
				item = key;
			}
			/* let item = _.find(this.getItems, search => {
                    return search._id == this.selected[0]
                })*/
			this.setIndex(this.getItems.indexOf(item));
			this.setItem(item);
			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},
		async editItem(key) {
			this.componentKey += 1;
			let item;

			if (!key) {
				let el = this.selected[0];
				item = _.find(this.getItems, i => {
					return i._id === el;
				});
			} else {
				item = key;
			}

			this.setClearError({});
			this.operation = 'FormEdit';

			this.setIndex(this.getItems.indexOf(item));
			this.setItem(item);
			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},
		async createItem() {
			this.componentKey += 1;
			this.setClearError({});

			this.operation = 'FormCreate';
			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},
		async importItemFromShopify() {
			this.componentKey += 1;
			this.setClearError({});
			this.operation = 'ImportShopify';
			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},
		async getFileCategories() {
			this.componentKey += 1;
			this.setClearError({});
			//await this.resetMessages();
			//console.log(this.getOrders.indexOf(item));
			//console.log(item)
			this.operation = 'FormFile';

			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},

		searchit: _.debounce(function () {
			if (_.size(this.searchfield) >= 2) {
				this.settings.search = this.searchfield;
				this.settings.options.page = 1;
			} else {
				this.settings.search = '';
				this.settings.options.page = 1;
			}
		}, 1000),
		propSetMessages(text) {
			this.setPreload(true);
			this.getDataFromApi().then(() => {
				this.snackbar.color = 'success';
				this.snackbar.text = 'Operazione effettuata con successo';
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 5000;
				this.selected = [];
				this.selectedall = [];
				this.setPreload(false);
			});
			this.operation = '';
			/*this.snackbar.color = 'success';
			this.snackbar.text = text;
			this.snackbar.text = text;
			this.snackbar.snackbar = true;
			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = 5000;*/
		},
		async getDataFromApi() {
			try {
				this.setPreload(true);
				this.isActive = true;
				//const {sortBy, sortDesc, page, itemsPerPage} = this.settings.options
				//console.log("Inizio this.fetchItems")

				let result = await this.fetchItems(this.settings);

				this.total = result.total;
				//this.items = result.data.data
				this.setPreload(false);
				this.selected = [];
				this.selectedall = [];
				this.$forceUpdate();

				//console.log(response);
			} catch (err) {
				console.log(err);
			}
		},
		async openNew() {
			this.setClearError({});
			//await this.resetMessages();
			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},

		/*checkpresenza(item) {
                return this.selected.includes(item)
            },
*/
		closeSnackbar() {
			this.setSnackbar(false);
		},
		async saveQt(item) {
			let payload = this.form;
			try {
				this.setPreload(true);

				await this.updateItems(item);

				this.getDataFromApi().then(() => {
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					this.setPreload(false);
				});
			} catch (err) {
				this.setPreload(false);
				console.log(err);
			}
		},
		async confirm() {
			/*let payload = this.form;
                try {
                    this.setPreload(true);
                    this.preload = true;
                    let response = await this.fetchUsers(payload);

                    this.getDataFromApi().then(res => {

                        this.snackbar.color = "success";
                        this.snackbar.text = this.$vuetify.lang.t(`$vuetify.messages.${data.data}`);
                        this.snackbar.snackbar = true;
                        this.snackbar.mode = 'multi-line';
                        this.snackbar.timeout = 5000;
                        this.setPreload(false);
                    })

                } catch (err) {
                    console.log(err);
                }
                this.preload = false;*/
		},
		async confirmFilter() {
			this.menu = false;
			await this.getDataFromApi();
		},

		async updateinventory(item) {
			item.variants.qt = 1;
			this.code = '';
			this.sku = '';

			await this.addTocart(item);
			await this.setElements([]);
			/*const carts = Array.from(await this.getItems);

			if (carts.length > 0) {
				const checkItem = carts.find(el => {
					return el._item === dto._item && el._variant === dto._variant;
				});
				if (checkItem) {
					checkItem.qt = checkItem.qt + 1;
				} else {
					carts.push(dto);
				}
			} else {
				carts.push(dto);
			}

			this.setItems(carts);
			console.log(this.getItems);*/
			//await this.addTocart(item);
		},
		// coppie chiave/valore della card di un prodotto candidato della lettura
		campiCandidato(item) {
			return [
				{ label: 'Brand', value: item?.brand?.trans?.name },
				{ label: 'Sku', value: item?.variants?.sku },
				{ label: 'Ean', value: item?.variants?.ean },
				{ label: 'Qt x unità', value: item?.variants?.qtunit },
			];
		},
		// coppie chiave/valore della card di una riga del carrello
		campiCarrello(item) {
			return [
				{ label: 'SKU', value: item?.sku },
				{ label: 'EAN', value: item?.sku ? item?.ean : '' },
				{ label: 'Qt x unità', value: item.qtunit },
				{ label: 'Price', value: item.price },
				{ label: 'Parziale', value: (item.price * item.qt).toFixed(2), strong: true },
			];
		},
		async deleteChip(type, value) {
			switch (type) {
				case 'search':
					this.searchfield = '';
					this.settings.search = '';
					this.settings.options.page = 1;
					break;
			}
			await this.getDataFromApi();
		},
		deleteItem(item) {
			this.deleteItems(item);
		},
		deleteCart(item) {
			this.deleteCarts(item);
		},
		async confermaCart(item) {
			this.setPreload(true);
			await this.confirmCarts(item);

			this.setPreload(false);
		},
		updateQt(item) {
			this.updateCart(item);
		},
		deleteItemInventory(item) {
			this.dialogconfirmdelete = true;
			this.form = item;
		},
		confirmItemInventory() {
			this.dialogconfirmImport = true;
		},

		confirmDeleteInventario() {
			this.dialogconfirmdelete = false;

			this.deleteInventory()
				.then(() => {
					this.setPreload(false);
					this.getDataFromApi().then(() => {
						this.snackbar.color = 'success';
						this.snackbar.text = 'Operazione effettuata con successo';
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.selected = [];
						this.selectedall = [];
					});
				})
				.catch(error => {
					console.log(error);
				});
			//this.deleteCategories()
		},
		confirmCart() {
			this.dialogconfirmImport = false;

			this.confirmCart()
				.then(() => {
					this.setPreload(false);
					this.getDataFromApi().then(() => {
						this.snackbar.color = 'success';
						this.snackbar.text = 'Operazione effettuata con successo';
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.selected = [];
						this.selectedall = [];
					});
				})
				.catch(error => {
					console.log(error);
				});
		},

		getImage(item) {
			let variant_id = item.variants?._id;
			if (variant_id) {
				let variant_ids = item.variants?.variants.map(item => item._id);
				let image = item.images.find(el => el.variants.includes(variant_id) || variant_ids.filter(item => el.variants.includes(item)).length > 0);
				if (image) {
					return image.sizes[0]?.value;
				} else {
					return false;
				}
			} else {
				return false;
			}
		},

		getVariants(string) {
			const keyValuePairs = string.split(',');

			return keyValuePairs.map(pair => {
				const [name, value] = pair.split(':');
				return { name, value };
			});
		},

		//this.deleteCategories()
	},
	mounted() {
		document.addEventListener('keypress', this.onKeypress);
	},
	beforeDestroy() {
		// Se si lascia la pagina a giro aperto, vanno staccati i listener del tutorial.
		this.tour.stop();
		document.removeEventListener('keypress', this.onKeypress);
		this.destroyData();

		//console.log('Main Vue destroyed')
	},
};
</script>

<style></style>

<style scoped>
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
/* card in lista fuori da v-data-table */
.kv-list > .kv-card + .kv-card {
	margin-top: 8px;
}
/* riepilogo del carrello in fondo alle card */
.cashout-summary {
	width: 100%;
	border-width: 2px;
}
</style>
